export default __webpack_public_path__ + "static/media/Head_6_Ear_3_C2.25ae854e.svg";